const bannerElement = document.querySelector('.home_banner_splide');

if (bannerElement) {
  let homeBannerSplide = new Splide(bannerElement, {
    arrows: false,
    autoplay: true,
    interval: 2000
  });
  homeBannerSplide.mount();
}